const ICONS = {
  success: '\u2713',
  error: '\u2717',
  warning: '\u26A0',
  info: '\u2139',
};

function getColors(type, t) {
  switch (type) {
    case 'success': return { bg: t.successBg, border: t.successBorder, text: t.successText };
    case 'error': return { bg: t.errorBg, border: t.errorBorder, text: t.errorText };
    case 'warning': return { bg: t.warningBg, border: t.warningBorder, text: t.warningText };
    case 'info': return { bg: t.infoBg, border: t.infoBorder, text: t.infoText };
    default: return { bg: t.cardBg, border: t.cardBorder, text: t.text };
  }
}

export default function Toast({ message, type = 'success', onDismiss, theme: t }) {
  const c = getColors(type, t);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '12px 16px',
        borderRadius: 10,
        background: c.bg,
        border: `1px solid ${c.border}`,
        color: c.text,
        fontSize: 13,
        fontWeight: 500,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        minWidth: 240,
        maxWidth: 380,
        animation: 'toast-in 0.3s ease',
      }}
    >
      <span style={{ fontSize: 16, lineHeight: 1, flexShrink: 0 }}>{ICONS[type]}</span>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={onDismiss}
        style={{
          background: 'none',
          border: 'none',
          color: c.text,
          cursor: 'pointer',
          fontSize: 16,
          padding: '0 2px',
          opacity: 0.6,
          lineHeight: 1,
          flexShrink: 0,
        }}
        aria-label="Dismiss"
      >
        {'\u00D7'}
      </button>
    </div>
  );
}
